import * as Sentry from "@sentry/gatsby";
import { sentryConfiguration } from "gatsby-theme-agria/src/utils/sentryConfiguration";

Sentry.init({
  ...sentryConfiguration,
  dsn: "https://5c2f839284eb48213616422e05939c26@o207017.ingest.us.sentry.io/4508002691252224",
});
